var React = require('react');

function IconMapSettingsWorkshopPoisActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#30B4C0","fillRule":"evenodd","d":"M12.528 9.322a5.362 5.362 0 0 1 6.872 6.872l10.032 10.032 2.101 2.102-3.2 3.2L16.274 19.37a5.362 5.362 0 0 1-6.95-6.85l3.785 3.786 3.202-3.201-1.474-1.474zm3.759 11.837l.948.948 1.263 1.264.948.947-7.19 7.19-3.159-3.16 7.19-7.189zM30.085 9.372l1.263 1.263-1.895 3.16-1.895.631-4.057 4.056-1.263-1.263 4.056-4.056.632-1.896 3.159-1.895z"}));
}

IconMapSettingsWorkshopPoisActive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsWorkshopPoisActive;

IconMapSettingsWorkshopPoisActive.default = IconMapSettingsWorkshopPoisActive;
